import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../service/globalService';
@Component({
  selector: 'app-no-auth',
  templateUrl: './no-auth.component.html',
  styleUrls: ['./no-auth.component.css']
})
export class NoAuthComponent implements OnInit {
  msg:boolean=false;
  inactive:boolean=false;
  constructor(private globalService: GlobalService) { this.globalService.setLoadingOff(); }

  ngOnInit() {
    if(localStorage.getItem('NotOktaUser')=="true"){
      //this.msg="User is not added in OKTA user group. For the OKTA groups the following AD Groups are used";
       this.msg=true;
      localStorage.removeItem('NotOktaUser');
    }
    else if(localStorage.getItem('Status')=="Inactive"){
      this.inactive=true;
      localStorage.removeItem('Status');
      localStorage.removeItem('NotOktaUser');
    }
    else{
     // this.msg="You currently do not have permission to access this page or EIP.";
     this.msg=false;
     localStorage.removeItem('NotOktaUser');
    }
    this.globalService.setLoadingOff();
  }

}
